import React from "react";
import {
	Body,
	Html,
	Container,
	Tailwind,
	Text,
	Button,
	Img,
	Heading,
	Head,
	Section,
} from "@react-email/components";
import { render } from "@react-email/render";

import aboutCartoon from "../../assets/About/aboutCartoon.jpg";

const Email = ({ props }) => {
	const { name, email, contact, subject, messageBody } = props;

	return (
		<Html>
			<Head />
			<Tailwind>
				<Body className="my-10 p-5 bg-white mx-auto font-sans border-2">
					<Container className="border-2 rounded-lg shadow-lg">
						<Heading className="p-5 text-2xl">Hi {name}👋</Heading>

						<Section className="my-5 text-center">
							<Text className="text-lg font-medium text-gray-700">
								{messageBody}
							</Text>
						</Section>

						<Text className="text-lg text-center">Ivanvielle B. Dupaya</Text>
						<Text className="mt-0 mb-3 text-md text-center italic">
							Web Developer
						</Text>
					</Container>
				</Body>
			</Tailwind>
		</Html>
	);
};

export const html = (props) => render(<Email props={props} />);

export default Email;
